import PropTypes from "prop-types"
import React, { useState } from "react"
import { AiOutlinePlus } from "react-icons/ai"
import styled from "styled-components"

// ----------------------------------------------------------------------------

function _RoomImagePicker(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { className, onUpload } = props

    // -------------------------------------
    // Hooks (e.g. useState, ...)
    // -------------------------------------

    const [isHovered, setIsHovered] = useState()

    // -------------------------------------
    // Memoized values
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    const hover = () => setIsHovered(true)
    const unhover = () => setIsHovered(false)

    function handleUpload(e) {
        const files = e.target.files
        onUpload && onUpload(files)
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <div
            className={`${className} ${isHovered && "hover"}`}
            onMouseEnter={hover}
            onMouseLeave={unhover}
            onPointerEnter={hover}
            onPointerLeave={unhover}
            onDragEnter={hover}
            onDragLeave={unhover}
            onDragStart={(e) => console.log("drag start")}
        >
            <AiOutlinePlus />
            <input
                type="file"
                className="image-input"
                onChange={handleUpload}
                accept="image/*"
            />
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_RoomImagePicker.propTypes = {
    className: PropTypes.string.isRequired,
}

_RoomImagePicker.defaultProps = {}

// ----------------------------------------------------------------------------

const RoomImagePicker = styled(_RoomImagePicker)`
    & {
        position: relative;
        width: 100%;
        height: 100%;
        min-height: 120px;
        border-radius: 10px;
        border: 2px dashed ${({ theme }) => theme.colors.dark250};
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        overflow: visible;
        transition: all 200ms ease;
        svg {
            width: 34px;
            height: 34px;
            fill: ${({ theme }) => theme.colors.dark400};
        }

        .image-input {
            display: block;
            height: 100%;
            width: 100%;
            position: absolute;
            opacity: 0;
            cursor: pointer;
        }

        &.hover {
            background-color: ${({ theme }) => theme.colors.dark100};
        }
    }
`
// ----------------------------------------------------------------------------

export default RoomImagePicker
